import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '@/shared/api/instance';
import type {
  BuyImmunityParams,
  BuyImmunityResponse,
  ImmunityError,
} from '../api/buyImmunity.types';

export const buyImmunity = createAsyncThunk<
  BuyImmunityResponse,
  BuyImmunityParams,
  { rejectValue: ImmunityError }
>('immunity/buy', async (params, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get<BuyImmunityResponse>('/app/purchases/buy-immunity', {
      params,
    });
    return data;
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.description ||
      error.response?.data?.message ||
      'Failed to buy immunity';

    return rejectWithValue({
      code: error.response?.status || 500,
      message: errorMessage,
    });
  }
});
